module.exports = "/_next/static/media/Video5.cac91bc514c2d91af90a350540a060c4.mp4";